import Vue from 'vue'
import api from 'api'

const state = {
    themes: [],
    voicePresets: [],
    voices: [],
    nbTexts: {},
    currentTheme: {
        persons: [],
        reals: []
    },
    currentPerson: {
        texts: []
    },
    currentText: {}
};

const getters = {
};

const mutations = {
    THEME_LIST_UPDATED(state, data)  {
        state.themes = data.themes;
        state.nbTexts = data.nbTexts;
    },
    CURRENT_THEME_UPDATED(state, currentTheme)  {
        state.currentTheme = currentTheme;
    },    
    PERSON_LIST_UPDATED(state, persons)  {
        Vue.set(state.currentTheme, 'persons', persons);
    },
    REAL_LIST_UPDATED(state, reals)  {
        Vue.set(state.currentTheme, 'reals', reals);
    },
    CURRENT_PERSON_UPDATED(state, {key, key2, data})  {
        if (!key && !key2)  {
            state.currentPerson = data;
        }
        else if (key && !key2)  {
            Vue.set(state.currentPerson, key, data);          
        }
        else if (key && key2)   {
            Vue.set(state.currentPerson[key], key2, data);            
        }
    },
    TEXT_LIST_UPDATED(state, texts)  {
        state.currentPerson.texts = texts;
    },
    TEXT_UPDATED(state, {textToUpdate, newData}) {
        Object.assign(textToUpdate, newData);
    },
    CURRENT_TEXT_UPDATED(state, {key, key2, data})  {
        if (!key && !key2)  {
            state.currentText = data;
        }
        else if (key && !key2)  {
            Vue.set(state.currentText, key, data);          
        }
        else if (key && key2)   {
            Vue.set(state.currentText[key], key2, data);            
        }
    },
    VOICE_PRESETS_UPDATED(state, newVoicePresets) {
        state.voicePresets = newVoicePresets;
    },
    VOICE_PRESET_ADDED(state, voicePresetToAdd) {
        state.voicePresets.push(voicePresetToAdd);
    }
};

const actions = {
    createTheme({rootState}, {newThemeName, callbacks})	{
        api.createTheme(rootState, newThemeName, callbacks);		
    },
    linkReal({rootState}, {themeId, email, callbacks})	{
        api.linkReal(rootState, themeId, email, callbacks);		
    },
    unlinkReal({rootState}, {themeId, userId, callbacks})	{
        api.unlinkReal(rootState, themeId, userId, callbacks);		
    },
    updateTheme({rootState}, {updatedThemeId, newName, callbacks}) {
        api.updateTheme(rootState, updatedThemeId, newName, callbacks);
    },
    deleteTheme({rootState}, {themeToDelete, callbacks}) {
        api.deleteTheme(rootState, themeToDelete, callbacks);
    },
    getThemeList({rootState}, {page = 1, callbacks})  {
        api.getThemeList(rootState, page, callbacks);
    },
    getTheme({rootState}, {themeId, callbacks})  {
        api.getTheme(rootState, themeId, callbacks);
    },
    createPerson({rootState}, {themeId, newPerson, picture = null, callbacks})  {
        api.createPerson(rootState, themeId, newPerson, picture, callbacks);
    },
    updatePerson({rootState}, {themeId, newPerson, picture = null, callbacks})  {
        api.updatePerson(rootState, themeId, newPerson, picture, callbacks);
    },
    deletePerson({rootState}, {personToDelete, callbacks}) {
        api.deletePerson(rootState, personToDelete, callbacks);
    },
    getPersonList({rootState}, {themeId, page = 1, callbacks})  {
        api.getPersonList(rootState, themeId, page, callbacks);
    },
    getPerson({rootState}, {personId, callbacks})  {
        api.getPerson(rootState, personId, callbacks);
    },
    getPersonDetail({rootState}, {personId, callbacks})  {
        api.getPersonDetail(rootState, personId, callbacks);
    },
    updateText({rootState}, {newText, updateRecordId, callbacks})  {
        api.updateText(rootState, newText, updateRecordId, callbacks);
    },
    deleteText({rootState}, {textToDelete, callbacks}) {
        api.deleteText(rootState, textToDelete, callbacks);
    },
    getText({rootState}, {textId, callbacks})  {
        api.getText(rootState, textId, callbacks);
    },
    getTextList({rootState}, {personId, page = 1, callbacks})  {
        api.getTextList(rootState, personId, page, callbacks);
    },
    linkUserToPerson({rootState}, {personId, newUser, callbacks})  {
        api.linkUserToPerson(rootState, personId, newUser, callbacks);
    },
    linkPersonToText({rootState}, {textId, newPerson, callbacks})  {
        api.linkPersonToText(rootState, textId, newPerson, callbacks);
    },
    textToSpeech({rootState}, {textToSpeechData, callbacks})  {
        api.textToSpeech(rootState, textToSpeechData, callbacks);
    },
    generateVoiceForText({rootState}, {textId, textToSpeechData, callbacks})  {
        api.generateVoiceForText(rootState, textId, textToSpeechData, callbacks);
    },
    generateVoicesForPerson({rootState}, {personId, textToSpeechData, callbacks})  {
        api.generateVoicesForPerson(rootState, personId, textToSpeechData, callbacks);
    },
    getVoicePresets({rootState, commit}, callbacks = {}) {
        api.getVoicePresets(rootState, {
            success(voicePresets) {
                commit('VOICE_PRESETS_UPDATED', voicePresets)
                if (callbacks.success) {
                    callbacks.success();
                }
            }
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};